import * as t from "io-ts";
import { FinanceRate } from "./FinanceRate";
import { JobItem } from "./JobItem";
import { Money } from "./Money";
import { MoneyTotal } from "./MoneyTotal";
import { WorkType } from "./WorkType";

export const LeadQuote = t.intersection([
  t.type({
    work_type: WorkType,
    work_finished_by: t.union([
      t.literal("as soon as possible"),
      t.literal("within 1 month"),
      t.literal("within 3 months"),
      t.literal("within 6 months"),
      t.literal("over 6 months"),
    ]),
    description: t.string,
  }),
  t.partial({
    finance_option: FinanceRate,
    job_items: t.array(JobItem),
    deposit: Money,
    total: MoneyTotal,
    reference: t.string,
  }),
]);

export interface LeadQuote {
  finance_option?: FinanceRate;
  work_type: WorkType;
  work_finished_by:
    | "as soon as possible"
    | "within 1 month"
    | "within 3 months"
    | "within 6 months"
    | "over 6 months";
  description: string;
  job_items?: Array<JobItem>;
  deposit?: Money;
  total?: MoneyTotal;
  reference?: string;
}
